export const FACE_RECOGNITION_STATUS = Object.freeze({
  NO_PHOTO: 'N',
  PROCESS: 'P',
  INVALID: 'I',
  VALID: 'V',
})

export const FACE_RECOGNITION_STATUS_LABEL = Object.freeze({
  VALID: 'Valid',
  INVALID: 'Invalid',
  EMPTY: 'Empty',
  WITH_PHOTO: 'With Photo',
  PENDING: 'Pending',
})

export const RFID_STATUS = Object.freeze({
  SUCCESS: 'S',
  PENDING: 'P',
})

/**
 * @param {object} params
 * @param {boolean} params.hasPhoto
 * @param {string[]} params.faceStatuses - Array of raw faceRecognition status values from vehicles
 */
export function getFaceRecognitionStatus({ hasPhoto, faceStatuses }) {
  if (!hasPhoto) return FACE_RECOGNITION_STATUS_LABEL.EMPTY

  if (faceStatuses.length === 0) return FACE_RECOGNITION_STATUS_LABEL.WITH_PHOTO
  if (faceStatuses.some((s) => s === FACE_RECOGNITION_STATUS.INVALID)) {
    return FACE_RECOGNITION_STATUS_LABEL.INVALID
  }

  if (faceStatuses.includes(FACE_RECOGNITION_STATUS.PROCESS)) {
    return FACE_RECOGNITION_STATUS_LABEL.PENDING
  }

  if (faceStatuses.every((s) => s === FACE_RECOGNITION_STATUS.VALID)) {
    return FACE_RECOGNITION_STATUS_LABEL.VALID
  }

  return FACE_RECOGNITION_STATUS_LABEL.WITH_PHOTO
}
